'use strict';
import {combineReducers} from 'redux';
import {createMilestoneRequestModal} from '../redux/createMilestone';
import {reduxList as projectMilestoneList} from '../redux/projectMilestoneList';
import {
  CREATE_MILESTONE_NAME,
  PROJECT_MILESTONE_LIST_NAME,
  TEMPLATE_MILESTONE_LIST_NAME,
  UPDATE_MILESTONE_NAME,
} from '../redux/state';
import {reduxList as templateMilestoneList} from '../redux/templateMilestoneList';
import {updateMilestoneRequestModal} from '../redux/updateMilestone';


export * from './state';

export const milestones = combineReducers({
  [CREATE_MILESTONE_NAME]: createMilestoneRequestModal.reducers.reducer,
  [PROJECT_MILESTONE_LIST_NAME]: projectMilestoneList.reducers.reducer,
  [TEMPLATE_MILESTONE_LIST_NAME]: templateMilestoneList.reducers.reducer,
  [UPDATE_MILESTONE_NAME]: updateMilestoneRequestModal.reducers.reducer,
});



// WEBPACK FOOTER //
// ./src/js/milestones/reducers/index.js